import { memo, useCallback, useContext, useState } from "react";
import PropTypes from "prop-types";
import AmountContainer from "app/pages/.shared/AmountContainer";
import Badge from "app/pages/.shared/Badge";
import { FormattedMessage } from "react-intl";
import { quotationBoardShape } from "app/utils/propTypes";
import MoreDetails from "app/pages/.shared/MoreDetails";
import Paragraphs from "app/pages/.shared/Paragraphs";
import AmountSign from "app/pages/.shared/AmountSign/AmountSign";
import "./QuotationBoard.scss";
import AppGlobalsContext from "app/AppGlobalsContext";
import { BRANDS } from "app/constants";
import RadioFormik from "app/pages/.shared/form/RadioFormik";
import Button, { BUTTON_VARIANTS } from "app/pages/.shared/form/Button";

const QuotationBoard = ({ board = {}, included = false, expandedDetails, onChange }) => {
	const [showDetails, toggleDetails] = useState(expandedDetails);
	const { brand } = useContext(AppGlobalsContext);
	const isBrandSV = brand === BRANDS.SV;

	const toogleShowDetails = useCallback(
		event => {
			/** pour eviter de sélectionner le bouton radio au niveau des chambres */
			event.preventDefault();
			toggleDetails(!showDetails);
		},
		[showDetails]
	);

	const onBoardSelect = useCallback(() => {
		if (typeof onChange === "function") {
			onChange(board);
		}
	}, [board]);

	const showDetailsLabel = showDetails ? (
		<FormattedMessage id="product.page.less.details" />
	) : (
		<FormattedMessage id="product.page.more.details" />
	);

	return (
		<RadioFormik
			id={board.code}
			showIcon={true}
			name={"board"}
			toggle={onBoardSelect}
			value={board.code}
			data-testid={`quotation-board-${board.boardCode}`}
			body={
				board.paragraphs &&
				!isBrandSV &&
				board.paragraphs.length > 0 && (
					<div className="quotation-board__details">
						<Button
							variant={BUTTON_VARIANTS.BORDERLESS}
							className="quotation-board__details-button"
							onClick={toogleShowDetails}
							label={showDetailsLabel}
						/>

						<MoreDetails expanded={showDetails}>
							<Paragraphs paragraphs={board.paragraphs} enableHTMLFormatting={true} />
						</MoreDetails>
					</div>
				)
			}
		>
			{included ? (
				<div className="quotation-board__content">
					<div className="quotation-board__label" data-testid="board-label">
						{board.label}
					</div>
					<Badge>
						<FormattedMessage id="general.included" />
					</Badge>
				</div>
			) : (
				<div className="quotation-board__content">
					<div className="quotation-board__label" data-testid="board-label">
						{board.label}
					</div>
					<div className="quotation-board__upgrade-price">
						<AmountContainer
							amount={board.upgradePrice || 0}
							prefix={<AmountSign sign="+" />}
						/>
					</div>
				</div>
			)}
		</RadioFormik>
	);
};

QuotationBoard.propTypes = {
	board: quotationBoardShape,
	expandedDetails: PropTypes.bool,
	included: PropTypes.bool,
	onChange: PropTypes.func,
};

export default memo(QuotationBoard);
